<template>
  <div class="cb-popop--container" @touchmove.prevent>
    <transition name="dialog-mask">
      <div class="cb-popup__mask" @click="onMask" v-show="show" />
    </transition>
    <transition name="dialog-bounce">
      <div class="cb-popup__dialog--container" v-show="show">
        <slot>
          <div class="cb-popup__dialog__content">
            <i v-if="showCloseButton" class="cb-popup__dialog__content__close" @click="handleAction('close')" />

            <div class="cb-popup__dialog__content__title" v-if="title || $slots.title">
              <span class="cb-popup__dialog__content__pic">
                <slot name="pic">
                  <img :src="pic" v-if="pic" />
                </slot>
              </span>
              <slot name="title">
                {{ title }}
              </slot>
            </div>

            <div class="cb-popup__dialog__content__message" v-if="message || $slots.message">
              <slot name="message">
                <div v-html="message"></div>
              </slot>
            </div>

            <div
              class="cb-popup__dialog__content__buttons"
              v-if="showCancelButton || showConfirmButton || showbackButton || showContactButton || $slots.buttons"
            >
              <slot name="buttons">
                <a
                  class="cb-popup__dialog__content__buttons__item confirm"
                  @click="handleAction('confirm')"
                  v-if="showConfirmButton"
                >
                  {{ confirmButtonText }}
                </a>
                <a
                  class="cb-popup__dialog__content__buttons__item cancel"
                  @click="handleAction('cancel')"
                  v-if="showCancelButton"
                >
                  {{ cancelButtonText }}
                </a>
                <a
                  class="cb-popup__dialog__content__buttons__item confirm"
                  @click="handleAction('back')"
                  v-if="showbackButton"
                >
                  {{ backButtonText }}
                </a>
                <a
                  class="cb-popup__dialog__content__buttons__item confirm"
                  @click="handleAction('contact')"
                  v-if="showContactButton"
                >
                  {{ contactButtonText }}
                </a>
              </slot>
            </div>
          </div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CbDialog',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // v-model值
    value: {
      default: false,
      type: Boolean
    },
    pic: {
      default: '',
      type: String
    },
    // 点击蒙层时是否关闭弹窗
    closeOnClickOverlay: {
      default: false,
      type: Boolean
    },
    // 显示关闭按钮
    showCloseButton: {
      default: true,
      type: Boolean
    },
    // 显示取消按钮
    showCancelButton: {
      default: false,
      type: Boolean
    },
    // 显示确定按钮
    showConfirmButton: {
      default: false,
      type: Boolean
    },
    //显示返回按钮
    showbackButton: {
      default: false,
      type: Boolean
    },
    // 显示联系客服按钮
    showContactButton: {
      default: false,
      type: Boolean
    },
    // 标题
    title: {
      default: '',
      type: String
    },
    // 消息
    message: {
      default: '',
      type: String
    },
    // 取消按钮文案
    cancelButtonText: {
      default: '取消',
      type: String
    },
    // 确定按钮文案
    confirmButtonText: {
      default: '确定',
      type: String
    },
    //返回按钮文案
    backButtonText: {
      default: '我知道了',
      type: String
    },
    contactButtonText: {
      default: '联系客服',
      type: String
    },
    // 关闭之前做操作
    beforeClose: {
      default: null,
      type: Function
    },
    type: {
      default: '',
      type: String
    }
  },
  computed: {
  },
  watch: {
    value(newVal) {
      this.show = newVal;
    }
  },
  mounted() {},
  data() {
    return {
      show: this.value // 可见状态,
    };
  },
  methods: {
    // 遮罩
    onMask() {
      if (this.closeOnClickOverlay) {
        this.onClose();
      }
    },
    // 操作动作处理
    handleAction(action) {
      if (this.beforeClose) {
        /**
         * action [String] 操作动作，目前有cancel或confirm
         * state [Any] 只要为真就执行关闭
         */
        console.log(action, 'dialog action');
        this.beforeClose(action, (state) => {
          console.log(action, 'dialog action111');
          if (state !== false) {
            this.onClose(action);
          }
        });
      } else {
        this.onClose(action);
      }
    },
    // 关闭
    onClose(action) {
      this.show = false;
      this.$emit('change', this.show);
      this.$emit(action);
    }
  }
};
</script>

<style lang="less" scoped>
.cb-popop--container {
  display: flex;
  justify-content: center;
  align-items: center;
  .cb-popup__mask {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2001;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }
  .cb-popup__dialog--container {
    flex: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2001;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    line-height: initial;
    .cb-popup__dialog__content {
      position: relative;
      width: 85%;
      border-radius: 32px;
      background: #fff;
      text-align: center;
      .cb-popup__dialog__content__close {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 2001;
        line-height: 20px;
        border-radius: 50%;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
      }
      .cb-popup__dialog__content__title {
        font-size: 40px;
        color: #333333;
        text-align: center;
        font-weight: bold;
        line-height: 100px;
        padding-top: 16px;
      }
      .cb-popup__dialog__content__pic {
        img {
          width: 38px;
          height: 38px;
        }
      }
      .cb-popup__dialog__content__message {
        font-size: 32px;
        color: #333330;
        line-height: 48px;
        padding: 0 35px;
        margin: 2px 20px;
        // text-align: center;
      }
      .cb-popup__dialog__content__buttons {
        display: flex;
        flex-direction: column;
        text-align: center;
        margin: 40px 10px 0;
        // border-top: 1px solid #e8e8e8;
        // padding-top:u(29px);
        .cb-popup__dialog__content__buttons__item {
          flex: 1;
          height: 60px;
          line-height: 60px;
          padding: 20px;
          // margin: 0 u(10px);
          font-size: 16px;
          // background: #ff7f00;
          font-size: 36px;
          color: #176af0;
          font-weight: bold;
          // border: 1px solid #ff7f00;
          // border-radius: 18px;
          // text-align: center;
          &.confirm{
            background: linear-gradient(270deg, #3377FF 0%, #175CE6 100%);
            color: #ffffff;
            border-radius: 60px;
            margin:  0 32px;
            font-size: 32px;
          }
          &.cancel {
            background: transparent;
            color: #333333;
            // border-right: 1px solid #f4f4f4;
            font-size:28px;
            color: #666666;
            font-weight: 400;
          }
        }
      }
    }
  }
  .dialog-mask-enter-active {
    transition: all 0.3s;
  }
  .dialog-mask-leave-active {
    transition: all 0.3s;
  }
  .dialog-mask-enter,
  .dialog-mask-leave-to {
    opacity: 0;
  }
  .dialog-bounce-enter-active {
    transition: all 0.3s;
  }
  .dialog-bounce-leave-active {
    transition: all 0.3s;
  }
  .dialog-bounce-enter {
    transform: scale(0.7);
    opacity: 0;
  }
  .dialog-bounce-leave-to {
    transform: scale(0.9);
    opacity: 0;
  }
}
</style>
